import { useEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";
import useWindowWidthDebounced from "./useWindowWidth";

const OverFlowTooltip = ({
  children,
  placement = "bottom-start",
  title,
  className = "w-full max-w-full cellMaxWidth",
  ...rest
}) => {
  const contentRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const width = useWindowWidthDebounced();

  useEffect(() => {
    if (contentRef.current) {
      const el = contentRef.current;
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  }, [children, width]);

  const cellContent = (
    <div ref={contentRef} className={`truncate ${className}`} {...rest}>
      {children}
    </div>
  );

  return (
    <>
      {isOverflowed ? (
        <Tooltip title={title ?? children} placement={placement}>
          {cellContent}
        </Tooltip>
      ) : (
        cellContent
      )}
    </>
  );
};

export default OverFlowTooltip;
